// extracted by mini-css-extract-plugin
export default {"root":"ZiBkN","compact":"_1GJFi","priority-primary":"_2WEyV","priorityPrimary":"_2WEyV","disabled":"_2d6P5","priority-secondary":"_2yevU","prioritySecondary":"_2yevU"};